module.exports = __webpack_public_path__ + "img/lv-system.556ef271.jpg";